export default "__VITE_ASSET__DHJRiTu1__"